/* Elite Pet Food — Marquee dolgu: içeriği ekran genişliğini aşana kadar çoğaltıp
   2 özdeş grup oluşturur (translateX -50% ile kesintisiz loop, boşluk kalmaz). */
(function () {
  function setup(m) {
    var track = m.querySelector('.marquee__track');
    if (!track) return;
    var firstGroup = track.querySelector('.marquee__group');
    if (!firstGroup) return;
    if (!track.dataset.baseHtml) {
      track.dataset.baseHtml = firstGroup.outerHTML;
    }

    function build() {
      track.innerHTML = '';
      var tmp = document.createElement('div');
      tmp.innerHTML = track.dataset.baseHtml;
      var group = tmp.firstElementChild;
      if (!group) return;
      track.appendChild(group);

      var base = Array.prototype.slice.call(group.children);
      if (!base.length) return;
      var target = m.clientWidth * 1.15;
      var guard = 0;
      while (group.scrollWidth < target && guard < 80) {
        base.forEach(function (el) { group.appendChild(el.cloneNode(true)); });
        guard++;
      }
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);

      // Hız px/sn → süre = bir grup genişliği / hız (her ekranda aynı hız)
      var speed = parseFloat(m.dataset.speed) || 40;
      track.style.animationDuration = (group.scrollWidth / speed).toFixed(1) + 's';
    }

    build();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(build, 200);
    });
  }

  function run() {
    document.querySelectorAll('.marquee').forEach(setup);
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
